import { Flex, TextStyled } from '../../component-library';
import { VideoChat } from '../../components';

const customStyle = {
  videoBox: {
    position: 'fixed',
    top: 0,
    left: 0,
    visibility: 'hidden',
  },
  localParticipant: {
    width: 'auto',
    height: 'auto',
  },
};

const OptimaChart = ({ optimaData }) => {
  const getStyleValues = (textContent) => {
    const styleValues = {};

    styleValues['borderWidth'] = parseInt(textContent.value) / 8 ? parseInt(textContent.value) / 8 : 1;
    styleValues['borderStyle'] = 'solid';
    styleValues['padding'] = parseInt(textContent.key.replace('n', '')) / 3;
    styleValues['margin'] = (window.screen.availHeight - 3 * parseInt(textContent.key.replace('n', ''))) / 22 + 'px';
    styleValues['fontFamily'] = 'Times New Roman';

    return styleValues;
  };

  return (
    <Flex bg='white' width='100vw' alignItems='center' height='100vh' justifyContent='center'>
      <Flex flexDirection='column' maxHeight={window.screen.availHeight} maxWidth='75%'>
        <VideoChat stacked customStyle={customStyle} />
        {optimaData?.textContents?.map((textContent) => {
          return (
            <TextStyled key={textContent.key} textAlign='left' fontSize={textContent.value} style={getStyleValues(textContent)}>
              {textContent.content}
            </TextStyled>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default OptimaChart;
